import { AdminImpactEstimateReportsPage } from "./AdminImpactEstimateReportsPage";
import { useQuery } from "@tanstack/react-query";
import { LabService } from "../services/labService";

export const ConnectedAdminImpactEstimateReports = () => {
  const { data } = useQuery({
    queryKey: ["admin-lab-directory", "impact-reports"],
    queryFn: () => LabService.getAdminLabDirectory(),
    staleTime: 30_000,
  });

  const subscriptions = data?.summary.supported_lab_types ?? ["wet", "dry"];

  return <AdminImpactEstimateReportsPage labTypeSubscriptions={subscriptions} />;
};
